import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Item, Image, Divider, Button, Modal, Loader, Menu, Dimmer, Dropdown, Pagination, Icon } from 'semantic-ui-react'
import { logout, getProducts } from '../../actions/actionCreators'
import { backendService } from '../../services/backendService'
import Logo from '../../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';
import SubscriptionManageForm from './SubscriptionManageForm';
import Invoice from './Invoice'
import {loadStripe} from '@stripe/stripe-js';
import stripeOptions from '../../services/stripe';
import { Elements } from '@stripe/react-stripe-js';
import ProfileDeletionConfirmDialog from './ProfileDeletionConfirmDialog';
import ActiveSubscriptionItem from './ActiveSubscriptionItem';

const loadScript = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.addEventListener('load', () => {
      resolve({ successful: true })
    })
    script.addEventListener('error', event => {
      reject({ error: event })
    })
    document.head.appendChild(script)
  })

class Subscription extends React.Component {

  stripePromise = null

  constructor(props) {
    super()
    this.state = { 
      modalOpenEdit: props.editPlan ? props.editPlan : false,
      modalPlanUpdateOpenConfirm: false,
      loadingInvoices: false,
      loadingSubscription: false,
      customerId: {},
      subscription: {},
      subscriptionItem: null,
      newPlanQueries: 0,
      newPeriod: '',
      newCost: 0,
      newPlan: '',
      deletingAccount: false,
      modalOpenConfirm: false,
      modalOpenConfirmCancelSubscription: false,
      cancelingSubscription: false,
      invoices: [],
      trial: false,
      admin: false,
      product_type: 'lisia_standard',      
      product_id: null,
      product_details: null,
      productsLoaded: false,
      pricesLoaded: false,
      price_type: 'regular',
      product_prices: [],
      selectedPlanId: null,
      paymentMethodsLoaded: false,
      paymentMethods: [],
      paymentMethod: null,
      activePage: 1,
      invoiceLimit: 10
    }
  }
  
  handlePlanChange = (e, { value }) => {
    this.setState({errors: {...this.state.errors}})    
    this.setState({selectedPlanId: value })
  }

  componentWillMount = async () => {
    await this.getStripeUser();
    if (this.props.auth.type === 'user') {
      this.getProducts();
      this.getPaymentMethods();  
    }
  }

  componentDidMount = () => {

    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'User Subscription'
      }
    });
    
    sessionStorage.clear();
    const fetchData = async () => {
      const result = await loadScript('https://js.stripe.com/v3/')      
      if (result.successful)
        this.stripePromise = loadStripe(stripeOptions.api_key)
    };   

    fetchData();
  }

  getPaymentMethods = async () => {
    const payment_response = await backendService.get('/api/lawyers/' + this.props.auth.user.id + '/payment_methods')
     if( payment_response && payment_response.data ) {        
        this.setState({ paymentMethods: payment_response.data.data})   
        if (payment_response.data.data && payment_response.data.data.length > 0 )     
          this.setState({ paymentMethod: payment_response.data.data[0].id})
     }
    this.setState({paymentMethodsLoaded: true})
  }

  /**
   * get available products
   */
  getProducts = async () => {
    this.props.dispatch(getProducts()).then(() => {
      if (this.props.stripeState && this.props.stripeState.products) {        
        const products = this.props.stripeState.products.data
        let product = null     
        let product_id = null   
        products.forEach( item => {
            if (item.metadata.type === this.state.product_type && item.active === true) {
              product = item
              product_id = item.id
            }
        });
        this.setState({...this.state, product_id: product_id, product_details: product})
        this.getPrices(product_id)        
      }   
      this.setState({productsLoaded: true})   
    })
  }

  /**
   * get available product prices
   * @param {*} product_id 
   */
  getPrices = async (product_id) => {
    try {
      const response = await backendService.get(`/api/stripe/prices?product=${product_id}`)
      let availablePrices = []    
      const price_type = this.props.auth.user.price_type ? this.props.auth.user.price_type : this.state.price_type       
      if (response.data) {        
        const prices = response.data.data    
        for (let i = 0; i < prices.length; ++i) {
          const item = prices[i]          
          if (item.product === product_id && item.unit_amount !== null && item.active === true && 
            item.metadata.price_type && item.metadata.price_type === price_type) {        
            //has coupon? 
            let coupon_id = this.props.auth.user.coupon ? this.props.auth.user.coupon : item.metadata.coupon
            if(coupon_id) {           
              try {
                const couponResp = await backendService.get(`/api/stripe/coupons/${coupon_id}`);
                if (couponResp && couponResp.data) {
                  if (!couponResp.data.redeem_by || (((couponResp.data.redeem_by*1000) - new Date().getTime()) >= 0))
                    item.coupon = couponResp.data
                }
              } catch (exc) {
                console.error('Could not download coupon: ' + exc)
              }
            }    
            //compute amount
            item.amount = item.unit_amount
            availablePrices.push(item)                       
          } else  if (item.product === product_id && !item.unit_amount && item.recurring && item.active === true&& 
            item.metadata.price_type && item.metadata.price_type === price_type) {
            const itemResponse = await backendService.get(`/api/stripe/plans/${item.id}`);
            if (itemResponse && itemResponse.data) {
              const newItem = itemResponse.data            
              //has coupon? 
              let coupon_id = this.props.auth.user.coupon ? this.props.auth.user.coupon : item.metadata.coupon
              if(coupon_id) {             
                try {
                  const couponResp = await backendService.get(`/api/stripe/coupons/${coupon_id}`);
                  if (couponResp && couponResp.data)
                    if (!couponResp.data.redeem_by || (((couponResp.data.redeem_by*1000) - new Date().getTime()) >= 0))
                        newItem.coupon = couponResp.data
                } catch (exc) {
                  console.error('Could not download coupon: ' + exc)
                }
              } 
              newItem.amount = newItem.tiers && newItem.tiers[0] ? newItem.tiers[0].flat_amount : 0
              availablePrices.push(newItem)
            }
          }
        }  
        availablePrices.sort(function(a, b) { return a.amount - b.amount })    
        await this.setState({...this.state, product_prices: availablePrices})  
      }   
      this.setState({pricesLoaded: true})   
    }
    catch (error) {
      console.error(error)
      this.setState({...this.state, product_prices: [], pricesLoaded: false}) 
    }
  }

  /**
   *  get stripe customer infos
   */
  getStripeUser = async () => {
    this.setState({ loadingSubscription: true })
    const user = this.props.auth.user;   
    if(this.props.auth.type === 'admin') {
      this.setState({ loadingSubscription: false, admin: true })
      return
    }
    const response = await backendService.get(`/api/lawyers/${user.id}/stripe_customer`);
    const customer = response.data;
    await this.setState({ user: user , customerId: user.customerid });

    if (customer) {      
      if(response.data && response.data.subscriptions && response.data.subscriptions.data.length > 0) { 
        const lastSubscriptionIndex = customer.subscriptions.data.length - 1;
        await this.setState({ subscription: customer.subscriptions.data[lastSubscriptionIndex],    
                              subscriptionItem: customer.subscriptions.data[lastSubscriptionIndex].items.data[0],               
                              planId: customer.subscriptions.data[lastSubscriptionIndex].plan ? customer.subscriptions.data[lastSubscriptionIndex].plan.id : 
                                  customer.subscriptions.data[lastSubscriptionIndex].price ? customer.subscriptions.data[lastSubscriptionIndex].price.id : null
        });     
        
        await this.getInvoices();
        
        this.setState({ loadingSubscription: false });
        
      } else {        
        this.setState({ loadingSubscription: false })          
      }

    } else {
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))
      this.setState({ loadingSubscription: false })
    }

  }

  /**
   *  get user invoices
   */
  getInvoices = async () => {
    this.setState({ loadingInvoices: true})
    try {
      const offset = (this.state.activePage - 1) * this.state.invoiceLimit;
      const responseInv = await backendService.get(`/api/lawyers/${this.props.auth.user.id}/invoices`, {params: {limit: this.state.invoiceLimit, offset: offset}});
      if (responseInv.data.data && responseInv.data.data.length > 0)
        this.setState({ invoices: responseInv.data.data })
      else if (this.state.activePage > 1) {
        await this.setState({activePage: this.state.activePage -1 })
        this.getInvoices();
      }
    } catch (exc) {
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))     
    }    
    this.setState({loadingInvoices: false })
  } 

  handleOpenEdit = () => this.setState({ modalOpenEdit: true,  selectedPlanId: this.state.planId })

  handlePaymentMethodChanged = async () => this.getPaymentMethods();

  handleCloseEdit = () => this.setState({ modalOpenEdit: false })

  closeDeleteMessage = () => this.setState({ openDeleteMessage: false })

  handleCloseConfirm = () => this.setState({ modalOpenConfirm: false })

  handleCloseConfirmCancelSubscription = () => this.setState({ modalOpenConfirmCancelSubscription: false })

  askForCancelSubscriptionConfirm = () => this.setState({ modalOpenConfirmCancelSubscription: true })

  askForDeleteConfirm = () => this.setState({ modalOpenEdit: false, modalOpenConfirm: true })

  askForPlanUpdateConfirm = () => this.setState({ modalPlanUpdateOpenConfirm: true })

  closePlanUpdateConfirm = () => this.setState({ modalPlanUpdateOpenConfirm: false })

  cancelSubscriptionRenewal = async () => {
    try {
      this.setState({ loadingSubscription: true, cancelingSubscription: true })
      const response = await backendService.put(`/api/lawyers/${this.props.auth.user.id}/subscriptions/${this.state.subscription.id}`, {cancel_at_period_end: true});
      if (response && response.data) {      
        this.setState({subscription: response.data, modalOpenConfirmCancelSubscription: false, cancelingSubscription: false})        
      }
      
    } catch(e) 
    {} finally {
      this.setState({ loadingSubscription: false, cancelingSubscription: false })
    }
  }

  restoreSubscriptionRenewal = async () => {
    try {
      this.setState({ loadingSubscription: true })
      const response = await backendService.put(`/api/lawyers/${this.props.auth.user.id}/subscriptions/${this.state.subscription.id}`, {cancel_at_period_end: false});
      if (response && response.data) {      
        this.setState({subscription: response.data})
      }
      this.setState({ loadingSubscription: false })
    } catch(e) 
    {} finally {
      this.setState({ loadingSubscription: false })
    }
  }

  handlePlanChanged () {
    this.getPaymentMethods();
    this.getStripeUser();
    this.setState({ modalOpenEdit: false });
  }

  handleInvoicePaid() {
    this.getPaymentMethods();
    this.getStripeUser();
  }

  handleChangeLimit = (e, data) => { 
    this.setState({invoiceLimit: data.value}, () => {this.getInvoices()})
  }

  handleChangePage = (e, data) => {
    this.setState({activePage: data.activePage}, () => {this.getInvoices()})
  }

  render() {

    const paginationOptions = [
      { key: 0, text: '10', value: 10 },
      { key: 1, text: '25', value: 25 },
      { key: 2, text: '50', value: 50 },
      { key: 3, text: '100', value: 100 },
    ]
    return (
      <Elements stripe={this.stripePromise} locale={this.context.language.id}>  
        <Row>
           
          <Col xs={8} sm={4} md={3} className='lisia-app-logo-wrapper'>
            <Link to='/'>
              <Image src={ Logo } />
            </Link>
          </Col>
                      
          <Col className="lisia-app-card-content subscription centered" xs={12} md={10}>
                      
            <div className='lisia-app-header'>
              <div className='header'>
                <Link to='/'>
                  <Text tid="back" />
                </Link>            
              </div>          
              { this.state.admin ?
                  <h3 className='text-center lisia-app-card-title'><Text tid="subscription_admin_alert" /></h3>                                  
                :
                  this.state.trial ? 
                    <h3 className='text-center lisia-app-card-title'><Text tid="subscription_trial_alert" /></h3> 
                  : 
                    <h3 className='text-center lisia-app-card-title '><Text tid="subscription_title" /></h3> 
              }
            </div> 
            <Divider />
            {this.state.loadingSubscription &&
              <Loader active inline='centered' className='marginLoadMore' />
            }                    
            { !this.state.loadingSubscription && !this.state.admin && 
              <>     
                      <ActiveSubscriptionItem 
                          subscription={this.state.subscription} 
                          subscriptionItem={this.state.subscriptionItem} 
                          restoreSubscriptionRenewal={this.restoreSubscriptionRenewal.bind(this)} 
                          askForCancelSubscriptionConfirm={this.askForCancelSubscriptionConfirm.bind(this)} 
                      />
                      <Button 
                          icon 
                          labelPosition='right' 
                          floated='right' 
                          className='lisia-blue' 
                          style={{minWidth: '228px', right: '5px'}} 
                          onClick={this.handleOpenEdit}
                      >
                          <Text tid='subscription_edit_or_cancel' />
                          <Icon name='edit' />
                      </Button> 
                      {this.state.modalOpenConfirm && <ProfileDeletionConfirmDialog visible={this.state.modalOpenConfirm} dialogCloseCallback={this.handleCloseConfirm.bind(this)}> </ProfileDeletionConfirmDialog> }
                      <Modal
                        open={this.state.modalOpenConfirmCancelSubscription}
                        onClose={this.handleCloseConfirmCancelSubscription}
                        className='lisia-modal lisia-dialog'
                      >
                        <Modal.Content>
                          <Dimmer.Dimmable dimmed={this.state.cancelingSubscription}>
                            <h3 className='text-center'>{this.props.auth.user.name}<Text tid='subscription_cancel_renewal_confirm' /></h3>
                            <Divider />                            
                            <h5 className='text-center'><Text tid='subscription_cancel_renewal_confirm_details' /></h5>
                            <Dimmer active={this.state.cancelingSubscription} inverted>
                              <Loader size='large'><Text tid='loading' /></Loader>
                            </Dimmer>
                          </Dimmer.Dimmable>
                          <Button disabled={this.state.cancelingSubscription} negative onClick={this.cancelSubscriptionRenewal} style={{width: '100%'}}><Text tid='subscription_cancel_renewal' /></Button>
                        </Modal.Content>
                        <Modal.Actions>
                          <div className='footer'>
                            <Link onClick={this.handleCloseConfirmCancelSubscription} to='#'>
                                <Text tid="back" />
                              </Link>  
                          </div>
                        </Modal.Actions>
                      </Modal>                                                 
                      <Modal             
                        open={this.state.modalOpenEdit && this.stripePromise && this.state.productsLoaded && this.state.pricesLoaded && this.state.paymentMethodsLoaded}
                        onClose={this.handleCloseEdit}
                        onOpen={this.handleOpenEdit}
                        className='lisia-modal lisia-dialog'
                      >
                        <Modal.Content>
                          <h3 className='text-center'><Text tid='subscription_change_plan' /></h3>                  
                          <Divider />
                          <p className='text-center'><Text tid='subscription_change_plan_description' /></p>                            
                          <SubscriptionManageForm 
                            state={this.state} 
                            planChanged={this.handlePlanChanged.bind(this)}
                            paymentMethodChanged={this.handlePaymentMethodChanged.bind(this)}
                          />
                        </Modal.Content>
                        <Modal.Actions>
                        <div className='footer'>
                            <Link onClick={this.handleCloseEdit} to='#'>
                                    <Text tid="back" />
                            </Link>  
                            <Link onClick={this.askForDeleteConfirm} to='#'>
                                    <Text tid="subscription_delete_your_account" />
                            </Link>                 
                          </div>                  
                        </Modal.Actions>
                      </Modal>
                      <br/>
                      <br/>
                  {!this.state.loadingSubscription && this.state.loadingInvoices &&
                    <Loader active inline='centered' className='marginLoadMore' />
                  }
                  {!this.state.loadingSubscription && !this.state.loadingInvoices && this.state.invoices.length > 0 &&
                    <>
                    <h3 className='text-center'><Text tid="subscription_payment_list_title" /></h3>
                    <Divider />
                      <Item.Group divided style={{paddingRight: '5px', maxHeight: '400px', overflow: 'auto'}}>
                        {this.state.invoices.map((invoice, i) => {
                          return ( 
                            <Invoice 
                              payment_method={this.state.paymentMethod}
                              invoice={invoice}
                              key={i}
                              successCallback={this.handleInvoicePaid.bind(this)}
                            /> 
                          )
                        })
                        }
                      </Item.Group>
                      <Divider />
                    </>
                  }              
              </>
            }          
          </Col>
        </Row> 
        { this.props.auth.type === 'user' && this.state.invoices.length ?       
          <Row>
            <Col className="centered subscription lisia-pagination" xs={12} md={10}>
              <Menu compact>
                <Dropdown
                  value={this.state.invoiceLimit}
                  fluid
                  selection
                  options={paginationOptions}
                  onChange={this.handleChangeLimit}
                />
              </Menu>
              <Pagination                 
                activePage={this.state.activePage}
                totalPages={this.state.activePage + 1} 
                onPageChange={this.handleChangePage}
                firstItem={null}
                lastItem={null}
                siblingRange={0}
                boundaryRange={0}
                ellipsisItem={null}
              />
            </Col>
          </Row> : <></>
        }
      </Elements>
    )
  }
}

Subscription.contextType = LanguageContext;

const mapStateToProps = (state) => ({
  stripeState: state.stripeState,
  auth: state.auth,
  usage: state.articles.usage !== undefined ? state.articles.usage : false,
  dispatchError: state.articles.error !== undefined ? state.articles.error : false,
  errorMessage: state.articles.message !== undefined ? state.articles.message : false,
  articles: state.articles !== undefined ? state.articles : false
})

export default connect(mapStateToProps)(Subscription)